import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import leftarrow from "../../Assets/Images/CreateBatch/Group27.png";
import rightarrow from "../../Assets/Images/CreateBatch/Group27(1).png";
import DatePicker from "react-datepicker";
import SearchCB from "../../Assets/Images/CreateRole/Search.png";
import Informative from "../../Assets/Images/CommanImages/Informative.png";
import "react-datepicker/dist/react-datepicker.css";
import format from "date-fns/format";
import SelectDropdown from "../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import { FULL_API_BASE_URL } from "../../Config/Config";
import "./CreateBatchV2.css";
import YellowSearch from "../../Assets/Images/CommanImages/searchyellow.png";
import BlankDropdown from "../CreateQuestionsPaper/DppScheduling/BlankDropdown";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";

const AssignBatch = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  setNoTimeSet,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [sliderValue, setSliderValue] = useState([65, 70]);
  const [singleValue, setSingleValue] = useState({ year: 2014, month: 11 });
  const handleSliderChange = (value) => {
    setSliderValue(value);
  };
  const [selectedClass, setSelectedClass] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [selectedButton, setSelectedButton] = useState(25);
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
  const user_name = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
  const clientBranchId = dataClient?.client_schema_name[6][0].client_branch_id;
  const userId = dataClient?.client_schema_name[6][0].user_id;
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [secondTableStudentIds, setSecondTableStudentIds] = useState([]);
  const [studentTypeId, setStudentTypeId] = useState(null);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [courses, setCourses] = useState([]);
  const [batchName, setBatchName] = useState("");
  const [courseOpted, setCourseOpted] = useState("");
  const [coachingMode, setCoachingMode] = useState("");
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [studentData, setStudentData] = useState([]);
  const [selectedClassObj, setSelectedClassObj] = useState(null);
  const [initialData, setInitialData] = useState([]);
  const [firstTableData, setFirstTableData] = useState([]);
  // Right list is just whichever students are currently checked - checking a
  // box in the left list adds them here, unchecking (in either list) removes
  // them. No separate "move" step needed.
  const secondTableData = studentData.filter((student) =>
    selectedStudentIds.includes(student.student_id)
  );
  const [excludeAssigned, setExcludeAssigned] = useState(true);
  const [tentativeExamDate, setTentativeExamDate] = useState(new Date());
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [secondSearchTerm, setSecondSearchTerm] = useState("");
  const [secondTableCount, setSecondTableCount] = useState(0);
  const [firstTableCount, setFirstTableCount] = useState(0);
  const [batches, setBatches] = useState([]);
  const [batchDescription, setBatchDescription] = useState("");
  const [batchCode, setBatchCode] = useState("");
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const params = new URLSearchParams(location.search);
  const courseId = params.get("course_id");
  const classId = params.get("class_id");
  const classType = params.get("class_type");
  const batchIdParam = params.get("batch_id");
  const sessionIdParam = params.get("session_id");
  const [sessionData, setSessionData] = useState([]);
  const [selectedSessionId, setSelectedSessionId] = useState("");
  // Batch, session, course, class and type all come from the row picked on
  // the Batch Dashboard - lock the dropdowns/radios so they only display
  // those values instead of allowing them to be changed here.
  const cameFromDashboard = Boolean(batchIdParam);

  const coachingModeOptions = [
    { id: "Online", label: "Online" },
    { id: "Classroom", label: "Classroom" },
    { id: "Hybrid", label: "Hybrid" },
  ];
  const classTypeAbbreviations = {
    Online: "OL",
    Classroom: "CL",
    Both: "H",
  };
  const classTypeToId = {
    Online: 1,
    Classroom: 2,
    Both: 3,
  };

  const handleStyle = {
    borderRadius: 0,
    backgroundColor: "#EFEFEF",
    border: "2px solid #999999",
    height: "28px",
    width: "20px",
    opacity: 1,
  };

  const trackStyle = {
    backgroundColor: "#D6D6D6",
    height: "20px",
    border: "1px solid #999999",
  };

  const railStyle = {
    borderRadius: 0, // Add this line
    backgroundColor: "#FFFFFF",
    height: "20px",
    border: "2px solid #999999",
  };

  // Define state variables for selected course and class IDs

  useEffect(() => {
    const fetchCourses = async () => {
      const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`);
      const data = await response.json();
      setCourses(data);
    };

    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchClasses = async () => {
      const response = await fetch(`${FULL_API_BASE_URL}/get-classes/`);
      const data = await response.json();
      setSelectedClass(data); // Save the entire class object in the state
    };

    fetchClasses();
  }, []);

  useEffect(() => {
    if (!courseId && !classId && !classType) return;
    setSelectedCourseId(Number(courseId));
    setSelectedClassId(Number(classId));
    setStudentTypeId(Number(classType));
    setSelectedSessionId(Number(sessionIdParam));
  }, [courseId, classId, classType, sessionIdParam]);

  // The target batch is whatever was selected on the Batch Dashboard - once
  // the batch list loads, find that batch and use it directly instead of
  // asking the user to pick one again on this page.
  useEffect(() => {
    if (!batchIdParam || batches.length === 0) return;
    const matchedBatch = batches.find(
      (batch) => batch.batch_id === Number(batchIdParam)
    );
    if (matchedBatch) {
      setSelectedBatch(matchedBatch);
    }
  }, [batchIdParam, batches]);

  useEffect(() => {
    const fetchBatches = async () => {
      const response = await fetch(`${FULL_API_BASE_URL}/get-batches/`);
      const data = await response.json();
      setBatches(data.data);
    };

    fetchBatches();
  }, []);

  const handleCourseSelection = (selectedCourseId) => {
    const selectedCourse = courses.find(
      (course) => course.course_id === selectedCourseId
    );
    setSelectedCourse(selectedCourse);
    setSelectedCourseId(selectedCourse.course_id);
    setSelectedCourseName(selectedCourse.course_name);
    // Reset class when course changes
    setSelectedClassObj(null);
    setStudentData([]);
    setFirstTableData([]);
  };

  const handleClassSelection = (selectedClassId) => {
    const selectedClassObj = classes.find(
      (classObj) => classObj.class_id === selectedClassId
    );
    setSelectedClassObj(selectedClassObj);
    setSelectedClassId(selectedClassId); // ✅ ADD THIS
    setSelectedClassName(selectedClassObj.class_name);
  };

  const AssignBatch = async () => {
    // Validate: only batch selection is required
    if (!selectedBatch) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select a Batch.</span>
          </div>
        </div>
      );
      return;
    }

    // Validate: at least one student must be assigned
    if (secondTableData.length === 0) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please assign at least one student.</span>
          </div>
        </div>
      );
      return;
    }

    const studentsFormattedForSecondAPI = secondTableData.map((student) => ({
      student_id: student.student_id,
      added_by: user_name,
    }));

    const hasAssignedStudents = secondTableData.some(
      (student) =>
        student.batch_name !== null &&
        student.batch_name !== "" &&
        student.batch_name !== "Not Assigned"
    );

    const postAssignedBatch = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/assign-batch?batch_id=${selectedBatch.batch_id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(studentsFormattedForSecondAPI),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log(data);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Batch assigned successfully.</span>
            </div>
          </div>
        );
        setActiveImg(Informative);
        setTimeout(() => {
          navigate("/batch_dashboard");
        }, 2000);
      } catch (error) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Error submitting the form. Please fill all the input fields.
              </span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
      }
    };

    if (hasAssignedStudents) {
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                These students are already assigned a batch. This will change
                their Batch. Are you sure you want to proceed?
              </span>
            </div>
            <div
              className="messagebox-insider2"
              style={{ display: "flex", gap: "10px", marginTop: "10px" }}
            >
              <button
                className="messagebox-cancel-btn-ok"
                onClick={() => {
                  setIsMessageBoxVisible(false);
                  postAssignedBatch();
                }}
              >
                YES
              </button>
              <button
                className="messagebox-cancel-btn-ok"
                onClick={() => setIsMessageBoxVisible(false)}
              >
                NO
              </button>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
      }
    } else {
      postAssignedBatch();
    }
  };

  const [classes, setClasses] = useState([]);

  useEffect(() => {
    const fetchClasses = async () => {
      const response = await fetch(`${FULL_API_BASE_URL}/get-classes/`);
      const data = await response.json();
      setClasses(data);
    };

    fetchClasses();
  }, []);

  useEffect(() => {
    if (!selectedCourseId || !selectedClassId || !studentTypeId) return;

    const fetchStudentData = async () => {
      const response = await fetch(
        `${FULL_API_BASE_URL}/student-list-batch-assign/?course_id=${selectedCourseId}&class_id=${selectedClassId}&student_type_id=${studentTypeId}&branch_id=${clientBranchId}&session_id=${selectedSessionId}`
      );
      const json = await response.json();
      const rawData = Array.isArray(json) ? json : json.data ?? [];
      const data = mapEmptyBatchToNoBatch(rawData);
      setStudentData(data);
    };

    fetchStudentData();
  }, [selectedCourseId, selectedClassId, studentTypeId, selectedSessionId]);

  // In your render method, when a checkbox is clicked
  const handleCheckboxClick = (studentId) => {
    setSelectedStudentIds((prevSelectedStudentIds) => {
      if (prevSelectedStudentIds.includes(studentId)) {
        // If the student is already selected, unselect them
        return prevSelectedStudentIds.filter((id) => id !== studentId);
      } else {
        // If the student is not selected, select them
        return [...prevSelectedStudentIds, studentId];
      }
    });
  };

  const mapEmptyBatchToNoBatch = (studentData) => {
    const transformedData = studentData.map((student) => ({
      ...student,
      batch_name:
        student.batch_name === "" ? "Not Assigned" : student.batch_name,
    }));
    return transformedData;
  };

  useEffect(() => {
    setFirstTableData([]);
    setTimeout(() => {
      if (excludeAssigned) {
        setFirstTableData(
          studentData.filter(
            (student) =>
              student.batch_name === null ||
              student.batch_name === "" ||
              student.batch_name === "Not Assigned"
          )
        );
      } else {
        setFirstTableData(studentData);
      }
    }, 0);
  }, [excludeAssigned, studentData]);

  useEffect(() => {
    setSecondTableCount(secondTableData.length);
  }, [secondTableData]);

  useEffect(() => {
    setFirstTableCount(firstTableData.length);
  }, [firstTableData]);

  const fetchSessionsData = async () => {
    try {
      const response = await fetch(`${FULL_API_BASE_URL}/get-sessions-list`, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();

      if (result.status === 200 && result.data) {
        const formattedSessions = result.data.map((session) => ({
          id: session.session_id,
          label: session.session_name,
        }));
        setSessionData(formattedSessions);

        if (sessionIdParam) {
          setSelectedSessionId(Number(sessionIdParam));
        } else {
          const latestSession = result.data.reduce((prev, current) =>
            prev.session_id > current.session_id ? prev : current
          );
          setSelectedSessionId(latestSession.session_id);
        }
      }
    } catch (error) {
      console.error("Error fetching sessions data:", error);
    }
  };

  useEffect(() => {
    fetchSessionsData();
  }, []);

  return (
    <div className="create-role-container">
      {/* Header */}
      <div
        className="create-role-container-tagging"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span className="create-role-heading">Assign Batch</span>
        <div className="cr-header-btn-container">
          <button
            className="create-test-section-btn"
            onClick={() => {
              navigate(`/batch_dashboard`);
            }}
          >
            CANCEL
          </button>
          <button className="create-test-section-btn" onClick={AssignBatch}>
            SAVE
          </button>
        </div>
      </div>
      {/* ASSIGN STUDENT Section */}
      <div className="parse-tagging">
        <div className="personal-header">
          <div className="header">
            <h2>SELECT STUDENT</h2>
          </div>
        </div>
        <div className="accordion-content-tagging-container">
          <div className="grid-container-tagging">
            <div className="grid-item">
              <SelectDropdown
                label="Session"
                style={{ width: "100%" }}
                selected={selectedSessionId}
                setSelected={setSelectedSessionId}
                options={sessionData}
                isRequired={true}
                disabled={cameFromDashboard}
              />
            </div>
            <div className="grid-item">
              <SelectDropdown
                label="Course"
                selected={selectedCourseId}
                setSelected={handleCourseSelection}
                style={{ width: "100%" }}
                options={courses.map((course) => ({
                  label: course.course_name,
                  id: course.course_id,
                }))}
                isRequired={true}
                disabled={cameFromDashboard}
              />
            </div>
            <div className="grid-item">
              <SelectDropdown
                label="Class"
                style={{ width: "100%" }}
                selected={selectedClassId}
                setSelected={handleClassSelection}
                options={selectedClass.map((classObj) => ({
                  id: classObj.class_id,
                  label: classObj.class_name,
                }))}
                isRequired={true}
                disabled={cameFromDashboard}
              />
            </div>
            <div className="grid-item">
              <div
                className="grid-item"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div style={{ display: "flex", gap: "24px" }}>
                  {[
                    { id: 1, label: "Online" },
                    { id: 2, label: "Classroom" },
                    { id: 3, label: "Both" },
                  ].map((type) => (
                    <label
                      key={type.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        color: "#6A6A6A",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        value={type.id}
                        checked={studentTypeId === type.id}
                        onChange={() => setStudentTypeId(type.id)}
                      />
                      <span style={{ marginLeft: "4px", fontSize: "14px" }}>
                        {type.label}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <hr className="dotted-hr ms-cs2 mb-cs2" />

          <div className="row-cs" style={{ marginLeft: "0px" }}>
            {/* ── Left Table ── */}
            <div className="col-cs grey-color-font">
              {/* Checkbox + Legend Row */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="form-check transparent-margin-all">
                  <input
                    className="form-check-input ms-cs3"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                    checked={excludeAssigned}
                    onChange={() => setExcludeAssigned(!excludeAssigned)}
                  />
                  <label
                    className="form-check-label mb-cs2 ms-cs2"
                    htmlFor="flexCheckChecked"
                  >
                    Exclude students with assigned batch
                  </label>
                </div>

                {/* Type Legend */}
                <div
                  style={{ display: "flex", alignItems: "center", gap: "15px" }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div className="rounded-rectangle-CBV2" />
                    <span
                      className="grey-color-font"
                      style={{ fontSize: "14px" }}
                    >
                      Online
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div className="rounded-rectangle-2-CBV2" />
                    <span
                      className="grey-color-font"
                      style={{ fontSize: "14px" }}
                    >
                      Classroom
                    </span>
                  </div>
                </div>
              </div>

              {/* Search */}
              <div className="div-contains-search-cvb">
                <input
                  className="input-search-cvb"
                  type="text"
                  onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                />
                <button
                  style={{
                    width: "5%",
                    backgroundColor: "white",
                    border: "none",
                  }}
                >
                  <img src={YellowSearch} className="search-cvb" alt="" />
                </button>
              </div>

              {/* Left Table */}
              <div className="cr-bt-table-scroll-container-v2">
                <table
                  className="table-CBV2-1"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed",
                    border: "none",
                  }}
                >
                  <thead
                    style={{
                      position: "sticky",
                      top: "0",
                      zIndex: "1",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <tr style={{ border: "1px solid #999", height: "30px" }}>
                      <th
                        style={{
                          border: "none",
                          fontSize: "14px",
                          width: "30%",
                          color: "#6A6A6A",
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          border: "none",
                          fontSize: "14px",
                          width: "20%",
                          color: "#6A6A6A",
                        }}
                      >
                        Roll. No.
                      </th>
                      <th
                        style={{
                          border: "none",
                          fontSize: "14px",
                          width: "20%",
                          color: "#6A6A6A",
                        }}
                      >
                        Current Batch
                      </th>
                      <th
                        style={{
                          border: "none",
                          fontSize: "14px",
                          width: "10%",
                          color: "#6A6A6A",
                        }}
                      >
                        Type
                      </th>
                      <th
                        style={{
                          border: "none",
                          fontSize: "14px",
                          width: "20%",
                          color: "#6A6A6A",
                        }}
                      >
                        Session
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {firstTableData
                      .filter(
                        (student) =>
                          (!excludeAssigned || student.batch_name !== "") &&
                          (student.full_name
                            .toLowerCase()
                            .includes(searchTerm) ||
                            student.roll_number
                              .toString()
                              .toLowerCase()
                              .includes(searchTerm))
                      )
                      .slice(
                        (currentPage - 1) * itemsPerPage,
                        currentPage * itemsPerPage
                      )
                      .map((student) => (
                        <tr
                          style={{ border: "1px solid #999" }}
                          key={student.student_id}
                        >
                          <td
                            style={{
                              width: "30%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              color: "#6A6A6A",
                            }}
                          >
                            <input
                              type="checkbox"
                              style={{
                                margin: 0,
                                marginRight: "5px",
                                verticalAlign: "middle",
                              }}
                              checked={selectedStudentIds.includes(
                                student.student_id
                              )}
                              onChange={() =>
                                handleCheckboxClick(student.student_id)
                              }
                            />
                            <span title={student.full_name}>
                              {student.full_name}
                            </span>
                          </td>
                          <td
                            style={{
                              width: "20%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              color: "#6A6A6A",
                            }}
                          >
                            {student.roll_number}
                          </td>
                          <td
                            style={{
                              width: "20%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              color: "#6A6A6A",
                            }}
                          >
                            {student.batch_name
                              ? student.batch_name
                              : "Not Assigned"}
                          </td>
                          <td style={{ width: "10%", color: "#6A6A6A" }}>
                            <div
                              className="center-items-cbv2"
                              style={{ justifyContent: "flex-start" }}
                            >
                              <div
                                className={
                                  student.class_type_id === 1
                                    ? "rounded-rectangle-CBV2"
                                    : student.class_type_id === 2
                                    ? "rounded-rectangle-2-CBV2"
                                    : ""
                                }
                              />
                            </div>
                          </td>
                          <td
                            style={{
                              width: "20%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              color: "#6A6A6A",
                            }}
                          >
                            <span title={student.session_name}>
                              {student.session_name}
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              {/* Left Table Footer */}
              <div className="row-cs mt-cs3">
                <div className="col-cs">
                  {firstTableData.length > 0 && (
                    <>
                      <p className="mt-cs1 ms-cs3 grey-color-font">
                        {
                          selectedStudentIds.filter((id) =>
                            firstTableData.some(
                              (student) => student.student_id === id
                            )
                          ).length
                        }{" "}
                        of {firstTableCount} selected.
                      </p>
                      <p className="mt-cs2 mb-cs2 ms-cs3 grey-color-font">
                        Change table size :
                        {[25, 50, 100].map((size) => (
                          <button
                            key={size}
                            className={`table-size-change-buttons ${
                              selectedButton === size ? "selected" : ""
                            }`}
                            onClick={() => {
                              setItemsPerPage(size);
                              setSelectedButton(size);
                            }}
                          >
                            {size}
                          </button>
                        ))}
                      </p>
                    </>
                  )}
                </div>
                <div className="col-cs">
                  <div className="pagination-cs">
                    <a
                      href="#"
                      className="leftarrow-rounded"
                      onClick={() => setCurrentPage(1)}
                    >
                      <img
                        className="leftarrow-pagination"
                        src={leftarrow}
                        alt=""
                      />
                    </a>
                    <a
                      href="#"
                      onClick={() =>
                        setCurrentPage(Math.max(1, currentPage - 1))
                      }
                    >
                      {"<"}
                    </a>
                    {Array(Math.ceil(secondTableData.length / itemsPerPage))
                      .fill()
                      .map((_, index) => (
                        <a
                          href="#"
                          className={index + 1 === currentPage ? "active" : ""}
                          onClick={() => setCurrentPage(index + 1)}
                        >
                          {index + 1}
                        </a>
                      ))}
                    <a
                      href="#"
                      onClick={() =>
                        setCurrentPage(
                          Math.min(
                            Math.ceil(firstTableData.length / itemsPerPage),
                            currentPage + 1
                          )
                        )
                      }
                    >
                      {">"}
                    </a>
                    <a
                      href="#"
                      className="rightarrow-rounded"
                      onClick={() =>
                        setCurrentPage(
                          Math.ceil(firstTableData.length / itemsPerPage)
                        )
                      }
                    >
                      <img
                        className="rightarrow-pagination"
                        src={rightarrow}
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Right Table ── */}
            <div className="col-cs" style={{ marginRight: "10px" }}>
              <div className="form-check transparent-margin-all grey-color-font">
                <label className="form-check-label">
                  {secondTableData.length} student
                  {secondTableData.length === 1 ? "" : "s"} selected for
                  batch:{" "}
                  <span style={{ fontSize: "15px", fontWeight: "bold" }}>
                    {selectedBatch ? selectedBatch.batch_name : ""}
                  </span>
                </label>
              </div>

              {/* Search */}
              <div className="div-contains-search-cvb-second">
                <input
                  className="input-search-cvb"
                  type="text"
                  onChange={(e) =>
                    setSecondSearchTerm(e.target.value.toLowerCase())
                  }
                />
                <button
                  style={{
                    width: "5%",
                    backgroundColor: "white",
                    border: "none",
                  }}
                >
                  <img src={YellowSearch} className="search-cvb" alt="" />
                </button>
              </div>

              {/* Right Table */}
              <div className="cr-bt-table-scroll-container-v2">
                <table
                  className="table-CBV2-1"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed",
                    border: "none",
                  }}
                >
                  <thead
                    style={{
                      position: "sticky",
                      top: "0",
                      zIndex: "1",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <tr style={{ border: "1px solid #999", height: "30px" }}>
                      <th
                        style={{
                          border: "none",
                          fontSize: "14px",
                          width: "30%",
                          color: "#6A6A6A",
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          border: "none",
                          fontSize: "14px",
                          width: "20%",
                          color: "#6A6A6A",
                        }}
                      >
                        Roll No.
                      </th>
                      <th
                        style={{
                          border: "none",
                          fontSize: "14px",
                          width: "20%",
                          color: "#6A6A6A",
                        }}
                      >
                        New Batch
                      </th>
                      
                      <th
                        style={{
                          border: "none",
                          fontSize: "14px",
                          width: "10%",
                          color: "#6A6A6A",
                        }}
                      >
                        Type
                      </th>
                      <th
                        style={{
                          border: "none",
                          fontSize: "14px",
                          width: "20%",
                          color: "#6A6A6A",
                        }}
                      >
                        Session
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {secondTableData
                      .filter(
                        (student) =>
                          student.full_name
                            .toLowerCase()
                            .includes(secondSearchTerm) ||
                          student.roll_number
                            .toString()
                            .toLowerCase()
                            .includes(secondSearchTerm)
                      )
                      .map((student) => (
                        <tr
                          style={{ border: "1px solid #999" }}
                          key={student.student_id}
                        >
                          <td
                            style={{
                              width: "30%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              color: "#6A6A6A",
                            }}
                          >
                            <span title={student.full_name}>
                              {student.full_name}
                            </span>
                          </td>
                          <td
                            style={{
                              width: "20%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              color: "#6A6A6A",
                            }}
                          >
                            {student.roll_number}
                          </td>
                          <td
                            style={{
                              width: "20%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              color: "#6A6A6A",
                            }}
                          >
                            <span title={selectedBatch ? selectedBatch.batch_name : ""}>
                              {selectedBatch ? selectedBatch.batch_name : ""}
                            </span>
                          </td>
                          <td style={{ width: "10%", color: "#6A6A6A" }}>
                            <div
                              className="center-items-cbv2"
                              style={{ justifyContent: "flex-start" }}
                            >
                              <div
                                className={
                                  student.class_type_id === 1
                                    ? "rounded-rectangle-CBV2"
                                    : student.class_type_id === 2
                                    ? "rounded-rectangle-2-CBV2"
                                    : ""
                                }
                              />
                            </div>
                          </td>
                          <td
                            style={{
                              width: "20%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              color: "#6A6A6A",
                            }}
                          >
                            <span title={student.session_name}>
                              {student.session_name}
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="row-cs mt-cs3">
                <div className="col-cs">
                  <p className="mt-cs1 ms-cs3 grey-color-font">
                    {
                      selectedStudentIds.filter((id) =>
                        secondTableData.some(
                          (student) => student.student_id === id
                        )
                      ).length
                    }{" "}
                    of {secondTableCount} selected.
                  </p>
                  {/* Invisible spacer matching the left table's "Change
                      table size" row (shown under the same condition), so
                      both panels stay the same height */}
                  {firstTableData.length > 0 && (
                    <p
                      className="mt-cs2 mb-cs2 ms-cs3 grey-color-font"
                      style={{ visibility: "hidden" }}
                      aria-hidden="true"
                    >
                      Change table size :
                      {[25, 50, 100].map((size) => (
                        <button
                          key={size}
                          className="table-size-change-buttons"
                        >
                          {size}
                        </button>
                      ))}
                    </p>
                  )}
                </div>
                <div className="col-cs">
                  <div className="pagination-cs-2">
                    <a
                      href="#"
                      className="leftarrow-rounded"
                      onClick={() => setCurrentPage(1)}
                    >
                      <img
                        className="leftarrow-pagination"
                        src={leftarrow}
                        alt=""
                      />
                    </a>
                    <a
                      href="#"
                      onClick={() =>
                        setCurrentPage(Math.max(1, currentPage - 1))
                      }
                    >
                      {"<"}
                    </a>
                    {Array(Math.ceil(secondTableData.length / itemsPerPage))
                      .fill()
                      .map((_, index) => (
                        <a
                          href="#"
                          className={index + 1 === currentPage ? "active" : ""}
                          onClick={() => setCurrentPage(index + 1)}
                        >
                          {index + 1}
                        </a>
                      ))}
                    <a
                      href="#"
                      onClick={() =>
                        setCurrentPage(
                          Math.min(
                            Math.ceil(secondTableData.length / itemsPerPage),
                            currentPage + 1
                          )
                        )
                      }
                    >
                      {">"}
                    </a>
                    <a
                      href="#"
                      className="rightarrow-rounded"
                      onClick={() =>
                        setCurrentPage(
                          Math.ceil(secondTableData.length / itemsPerPage)
                        )
                      }
                    >
                      <img
                        className="rightarrow-pagination"
                        src={rightarrow}
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p
        style={{
          fontStyle: "italic",
          color: "#6A6A6A",
          fontSize: "13px",
          marginTop: "10px",
          marginLeft: "5px",
        }}
      >
        <span style={{ color: "#000000" }}>**</span>
        Students with the similar class only will appear in this list
      </p>
    </div>
  );
};

export default AssignBatch;